import {api, graph2, graph_vars, graph_vars_str, graph} from '../utils/shared'

export const agent_deep_link = async(token, fields, vars=[]) => {

    let p = graph_vars_str(vars)

    let vparams = p[0]
    let qparams = p[1]
    let j_params = p[2]

    let q = `query agent_deep_link ${vparams} {
            agent_deep_link ${qparams}
            {
                result
                    {
                        ${fields}
                    }
        error {
            ... on Unexpected_Error {
                message
            }
        }
    }
    }`

    let x = await graph_vars(q, j_params, token)
    return x
}

export const agent_deep_links = async(fields, token) => {

    let q = `query agent_deep_links {
            agent_deep_links
            {
                result
                    {
                        ${fields}
                    }
        error {
            ... on Unexpected_Error {
                message
            }
        }
    }
    }`

    let x = await graph2(q, token)
    return x
}
